module.exports = __webpack_public_path__ + "img/WeekDays.c778995a.svg";